import React, { useState } from 'react';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import Dashboard from './views/Dashboard';
import HowItWorks from './views/HowItWorks';
import FAQ from './views/FAQ';
import EmptyState from './components/EmptyState';
import EduOpsLogo from './components/EduOpsLogo';
import './index.css';

function App() {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const renderContent = () => {
    switch (activeTab) {
      case 'dashboard':
        return <Dashboard />;
      case 'demo':
        return <HowItWorks />;
      case 'faq':
        return <FAQ />;
      case 'students':
        return <EmptyState title="Student Directory" message="The centralized student ledger is currently offline for maintenance. Access will be restored shortly." icon="FiUsers" />;
      case 'schedule':
        return <EmptyState title="Master Schedule" message="No active schedule parameters detected for the current semester. Please initialize the Academic Module." icon="FiCalendar" />;
      case 'attendance':
        return <EmptyState title="Attendance Tiles" message="Real-time biometric sync is pending. Manual override is available in the Quick Action menu." icon="FiCheckSquare" />;
      case 'messages':
        return <EmptyState title="Communication Hub" message="Encrypted messaging relay is active but no new threads were found in your priority inbox." icon="FiMessageCircle" />;
      case 'tasks':
        return <EmptyState title="Staff Logistics" message="All operational tasks for the current shift have been logged or archived." icon="FiCheckCircle" />;
      default:
        return <Dashboard />;
    }
  };

  return (
    <div className="flex h-screen bg-[#020617] text-slate-50 font-sans selection:bg-blue-500/30 overflow-hidden relative">
      {/* Dynamic Background Elements */}
      <div className="absolute top-[-20%] left-[-10%] w-[60%] h-[60%] bg-blue-900/10 rounded-full blur-[150px] pointer-events-none" />
      <div className="absolute bottom-[-20%] right-[-10%] w-[50%] h-[50%] bg-orange-900/5 rounded-full blur-[120px] pointer-events-none" />

      <Sidebar 
        activeTab={activeTab} 
        setActiveTab={setActiveTab} 
        isOpen={isSidebarOpen} 
        setIsOpen={setIsSidebarOpen} 
      />
      
      <div className="flex-1 flex flex-col relative z-10 w-full min-w-0 transition-all duration-300">
        <Header toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)} />
        
        <main className="flex-1 overflow-y-auto p-4 md:p-6 lg:p-10 custom-scrollbar scroll-smooth relative">
          <div className="max-w-[1600px] mx-auto h-full flex flex-col">
            <div className="flex-1">
              {renderContent()}
            </div>
            
            <footer className="mt-20 py-10 border-t border-slate-900 flex flex-col items-center gap-6">
              <div className="flex items-center gap-3 opacity-30 grayscale hover:grayscale-0 hover:opacity-100 transition-all duration-500">
                <EduOpsLogo size="sm" />
                <span className="text-sm font-black tracking-tighter text-chalk uppercase">EduOps Systems v2.4.0</span>
              </div>
              <p className="text-[10px] text-slate-700 font-mono tracking-[0.3em] uppercase">
                Made by LingLink AI and DigLab AI
              </p>
            </footer>
          </div>
        </main>
      </div>
    </div>
  );
}

export default App;